import React from 'react';
import { Box, Typography, formatPrice } from '@lucid/lego';
import { useStore } from '../../../../store/store';
import styles from './Feature.module.scss';

type FeatureProps = {
  description: string;
  price: number;
  theme: 'dark' | 'light';
  /** i18n labels */
  labels?: Record<string, string>;
  value?: string | null | undefined;
};

/**
 * Feature component for displaying vehicle options and features
 * @component
 */
const Feature: React.FC<FeatureProps> = ({ description, price, theme, labels, value }) => {
  const locale = useStore((state) => state.locale);
  const formattedPrice = formatPrice(price, { locale });

  return (
    <Box className={styles.featureRow} theme={theme}>
      <Box className={styles.featureLabel}>
        <Typography variant="body" size="small" theme={theme}>
          {description}
        </Typography>
      </Box>
      <Box className={styles.featurePrice}>
        <Typography variant="body" size="small" theme={theme}>
          {value ?? (price === 0 ? (labels?.['vehicle.included'] ?? 'Included') : formattedPrice)}
        </Typography>
      </Box>
    </Box>
  );
};

Feature.displayName = 'Feature';

export default Feature;
